import React, { Component } from "react";
import { withFirebase } from "../Firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CardDeck from "react-bootstrap/CardDeck";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Badge from "react-bootstrap/Badge";
import Accordion from "react-bootstrap/Accordion";
const moment = require("moment");
class Consultations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      user_id: "",
      consultations: [],
      consultations_by_user: {}, //follows schema: {["user_id"]: [index of consultation]}
      user_data: {}, //follows schema: {["user_id"]: {user_data}}
      isChanged: false, // toggled when changes are made by the user
      users_id_array: [], // array of user ids
    };
  }
  componentDidMount() {
    const teamMembers = this.props.firebase.db.collection("team_members");
    const consultationsDB = this.props.firebase.db.collection(
      "consultations_new"
    );
    const users = this.props.firebase.db.collection("users");
    let {
      user_id,
      consultations,
      consultations_by_user,
      user_data,
      loading,
      users_id_array,
    } = this.state;
    this.props.firebase.auth.onAuthStateChanged(async (user) => {
      user_id = user.uid;
      await consultationsDB
        .where("consultant", "==", teamMembers.doc(user_id))
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            let consultation_object = doc.data();
            consultation_object.id = doc.id;
            consultations.push(consultation_object);
          });
        });
      for (let i = 0; i < consultations.length; i++) {
        consultations[i].date = consultations[i].date.toDate();
        let uid = consultations[i].user.id;
        if (consultations_by_user.hasOwnProperty(uid)) {
          consultations_by_user[uid].push(i);
        } else {
          users_id_array.push(uid);
          consultations_by_user[uid] = [i];
          user_data[uid] = await users
            .doc(uid)
            .get()
            .then((doc) => {
              return doc.data();
            });
        }
      }
      loading = false;
      this.setState({
        consultations,
        consultations_by_user,
        loading,
      });
    });
  }
  changeStatus(e, index) {
    let { consultations } = this.state;
    consultations[index].isChanged = true;
    consultations[index].status = e;
    this.setState({ isChanged: true, consultations: consultations });
  }
  changeCategory(e, index) {
    let { consultations } = this.state;
    consultations[index].category = e;
    consultations[index].isChanged = true;
    this.setState({ isChanged: true, consultations: consultations });
  }
  changeDuration(e, index) {
    let { consultations } = this.state;
    consultations[index].duration = parseInt(e);
    consultations[index].isChanged = true;
    this.setState({ isChanged: true, consultations: consultations });
  }
  saveChanges() {
    let { consultations, consultations_by_user, users_id_array } = this.state;
    this.setState({ loading: true });
    let remaining_flag = false;
    users_id_array.map((id) => {
      consultations_by_user[id].map((i) => {
        if (
          ((moment(consultations[i].date.toLocaleString()).isBefore(moment()) &&
            consultations[i].status === "pending") ||
            consultations[i].duration === "0") &&
          consultations[i].status !== "no_show"
        ) {
          alert(
            "There exists a consultations which should be completed where the status is still pending and/or the duration is still 0, please review your completed consultations and try again"
          );
          remaining_flag = true;
          return;
        }
      });
    });
    if (!remaining_flag) {
      const consultationsDB = this.props.firebase.db.collection(
        "consultations_new"
      );
      let promiseArray = [];
      consultations.forEach(async (consult) => {
        let data = consult;
        let id = data.id;
        delete data["id"];
        if (data.isChanged) {
          delete data["isChanged"];
          promiseArray.push(consultationsDB.doc(id).update(data));
        }
      });
      Promise.all(promiseArray).then(() => {
        window.location.reload();
      });
    }
  }

  setNotes(e, i) {
    let { consultations } = this.state;
    consultations[i].notes = e.target.value;
    consultations[i].isChanged = true;
    this.setState({ consultations, isChanged: true });
  }
  render() {
    let {
      consultations,   
      consultations_by_user,
      user_data,
      isChanged,
      users_id_array,
    } = this.state;
    let userTypeMap = {
      sme: "SME",
      entrepreneur: "Entrepreneur",
      mobile_app_owner: "Mobile app",
      employee_at_company_or_government: "Employee",
      student: "Student",
    };
    return (
      <Container>
        <Row>
          <Col>
            <CardDeck style={{ justifyContent: "center" }}>
              <Col>
                <Row>
                  <h3> Upcoming consultations</h3>
                </Row>
                <Col>
                  {users_id_array.map((id) => {
                    let hasPendingFlag = false;
                    consultations_by_user[id].map((i) => {
                      if (
                        moment(consultations[i].date.toLocaleString()).isAfter(
                          moment()
                        )
                      ) {
                        hasPendingFlag = true;
                      }
                    });
                    return hasPendingFlag ? (
                      <div>
                        <Accordion
                          style={{
                            textAlign: "center",
                            border: "none",
                            borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <Accordion.Toggle
                            as={Button}
                            eventKey="0"
                            variant="link"
                          >
                            {user_data[id].firstname +
                              " " +
                              user_data[id].familyname}
                            <Card.Subtitle className="mb-2 text-muted">
                              {typeof user_data[id].user_type === "string"
                                ? userTypeMap[user_data[id].user_type]
                                : user_data[id].user_type.map((type, i) => {
                                    return userTypeMap[type] + " | ";
                                  })}
                            </Card.Subtitle>
                            <Card.Subtitle className="mb-2 text-muted">
                              {user_data[id].email +
                                " | " +
                                user_data[id].phone}
                            </Card.Subtitle>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey="0">
                            <CardDeck style={{ justifyContent: "center" }}>
                              {consultations_by_user[id].map(
                                (consult_index) => {
                                  let html = (
                                    <Row>
                                      <Card>
                                        <Card.Body>
                                          <Card.Text>
                                            <h3>
                                              {moment(
                                                consultations[
                                                  consult_index
                                                ].date.toLocaleString()
                                              ).format(
                                                "dddd, MMMM Do YYYY, h:mm a"
                                              )}
                                            </h3>
                                          </Card.Text>
                                          <Accordion
                                            style={{
                                              textAlign: "center",
                                              border: "none",
                                            }}
                                          >
                                            <Card>
                                              <Accordion.Toggle
                                                as={Card.Header}
                                                eventKey="1A"
                                                variant="link"
                                              >
                                                Questions
                                              </Accordion.Toggle>
                                              <Accordion.Collapse eventKey="1A">
                                                <Card.Body>
                                                  {consultations[
                                                    consult_index
                                                  ].response.map((response) => {
                                                    return (
                                                      <Card.Text>
                                                        {"Q: " + response.text}
                                                        <br />
                                                        {"A: " +
                                                          response.answer}
                                                      </Card.Text>
                                                    );
                                                  })}
                                                </Card.Body>
                                              </Accordion.Collapse>
                                            </Card>
                                          </Accordion>
                                          <Form>
                                            <Form.Group>
                                              <Form.Label>Category</Form.Label>
                                              <Form.Control
                                                as="select"
                                                custom
                                                onChange={(e) => {
                                                  this.changeCategory(
                                                    e.target.value,
                                                    consult_index
                                                  );
                                                }}
                                                value={
                                                  consultations[consult_index]
                                                    .category !== undefined
                                                    ? consultations[
                                                        consult_index
                                                      ].category
                                                    : ""
                                                }
                                              >
                                                <option value="one_to_one">
                                                  1 - 1
                                                </option>
                                                <option value="rowad">
                                                  Rowad Thakaa
                                                </option>
                                                <option value="event">
                                                  Event
                                                </option>
                                                <option value="workshop_follow_up">
                                                  Workshop Follow Up
                                                </option>
                                                <option value="competition">
                                                  Competition
                                                </option>
                                              </Form.Control>
                                              <Form.Label>Status</Form.Label>
                                              <Form.Control
                                                as="select"
                                                custom
                                                onChange={(e) => {
                                                  this.changeStatus(
                                                    e.target.value,
                                                    consult_index
                                                  );
                                                }}
                                                value={
                                                  consultations[consult_index]
                                                    .status
                                                }
                                                disabled={moment(
                                                  consultations[
                                                    consult_index
                                                  ].date.toLocaleString()
                                                ).isAfter(moment())}
                                              >
                                                <option value="pending">
                                                  Pending
                                                </option>
                                                <option value="no_show">
                                                  No-Show
                                                </option>
                                                <option value="needs_follow_up">
                                                  Needs follow up
                                                </option>
                                                <option value="complete">
                                                  Completed
                                                </option>
                                              </Form.Control>
                                              <Form.Label>Notes:</Form.Label>
                                              <Form.Control
                                                as="textarea"
                                                rows="3"
                                                onChange={(e) => {
                                                  this.setNotes(
                                                    e,
                                                    consult_index
                                                  );
                                                }}
                                                value={
                                                  consultations[consult_index]
                                                    .notes
                                                }
                                              />
                                            </Form.Group>
                                          </Form>
                                          <Card.Link
                                            href={
                                              consultations[consult_index].cal
                                            }
                                          >
                                            Calendar Link
                                          </Card.Link>
                                        </Card.Body>
                                      </Card>
                                    </Row>
                                  );
                                  return moment(
                                    consultations[
                                      consult_index
                                    ].date.toLocaleString()
                                  ).isAfter(moment())
                                    ? html
                                    : null;
                                }
                              )}
                            </CardDeck>
                          </Accordion.Collapse>
                        </Accordion>
                      </div>
                    ) : null;
                  })}
                </Col>
              </Col>
            </CardDeck>
          </Col>
          <Col>
            <CardDeck style={{ justifyContent: "center" }}>
              <Col>
                <Row>
                  <h3> Completed Consultations</h3>
                  <Badge variant="danger" style={{ display: "inline-table" }}>
                    Review
                  </Badge>
                </Row>
                <Col>
                  {users_id_array.map((id) => {
                    let hasPendingFlag = false;
                    consultations_by_user[id].map((i) => {
                      if (
                        (moment(
                          consultations[i].date.toLocaleString()
                        ).isBefore(moment()) &&
                          consultations[i].status === "pending") ||
                        consultations[i].duration === "0"
                      ) {
                        hasPendingFlag = true;
                      }
                    });
                    return hasPendingFlag ? (
                      <div>
                        <Accordion
                          style={{
                            textAlign: "center",
                            border: "none",
                            borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <Accordion.Toggle
                            as={Button}
                            eventKey="0"
                            variant="link"
                          >
                            {user_data[id].firstname +
                              " " +
                              user_data[id].familyname}
                            <Card.Subtitle className="mb-2 text-muted">
                              {typeof user_data[id].user_type === "string"
                                ? userTypeMap[user_data[id].user_type]
                                : user_data[id].user_type.map((type, i) => {
                                    return userTypeMap[type] + " | ";
                                  })}
                            </Card.Subtitle>
                            <Card.Subtitle className="mb-2 text-muted">
                              {user_data[id].email +
                                " | " +
                                user_data[id].phone}
                            </Card.Subtitle>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey="0">
                            <CardDeck style={{ justifyContent: "center" }}>
                              {consultations_by_user[id].map(
                                (consult_index) => {
                                  let html = (
                                    <Row>
                                      <Card>
                                        <Card.Body>
                                          <Card.Text>
                                            <h3>
                                              {moment(
                                                consultations[
                                                  consult_index
                                                ].date.toLocaleString()
                                              ).format(
                                                "dddd, MMMM Do YYYY, h:mm a"
                                              )}
                                            </h3>
                                          </Card.Text>
                                          <Accordion
                                            style={{
                                              textAlign: "center",
                                              border: "none",
                                            }}
                                          >
                                            <Card>
                                              <Accordion.Toggle
                                                as={Card.Header}
                                                eventKey="1A"
                                                variant="link"
                                              >
                                                Questions
                                              </Accordion.Toggle>
                                              <Accordion.Collapse eventKey="1A">
                                                <Card.Body>
                                                  {consultations[
                                                    consult_index
                                                  ].response.map((response) => {
                                                    return (
                                                      <Card.Text>
                                                        {"Q: " + response.text}
                                                        <br />
                                                        {"A: " +
                                                          response.answer}
                                                      </Card.Text>
                                                    );
                                                  })}
                                                </Card.Body>
                                              </Accordion.Collapse>
                                            </Card>
                                          </Accordion>
                                          <Form>
                                            <Form.Group>
                                              <Form
                                                inline
                                                style={{
                                                  justifyContent: "center",
                                                  margin: "10px",
                                                }}
                                              >
                                                <Form.Label>
                                                  Duration
                                                </Form.Label>
                                                <Form.Control
                                                  as="select"
                                                  custom
                                                  onChange={(e) => {
                                                    this.changeDuration(
                                                      e.target.value,
                                                      consult_index
                                                    );
                                                  }}
                                                  value={
                                                    consultations[consult_index]
                                                      .duration
                                                  }
                                                >
                                                  <option value="0">0</option>
                                                  <option value="15">15</option>
                                                  <option value="30">30</option>
                                                  <option value="45">45</option>
                                                  <option value="60">60</option>
                                                  <option value="75">75</option>
                                                  <option value="90">90</option>
                                                  <option value="105">
                                                    105
                                                  </option>
                                                  <option value="120">
                                                    120
                                                  </option>
                                                  <option value="135">
                                                    135
                                                  </option>
                                                  <option value="150">
                                                    150
                                                  </option>
                                                  <option value="165">
                                                    165
                                                  </option>
                                                  <option value="180">
                                                    180
                                                  </option>
                                                  <option value="195">
                                                    195
                                                  </option>
                                                  <option value="210">
                                                    210
                                                  </option>
                                                  <option value="225">
                                                    255
                                                  </option>
                                                  <option value="240">
                                                    240
                                                  </option>
                                                </Form.Control>
                                                {consultations[consult_index]
                                                  .duration === "0" ? (
                                                  <Badge
                                                    variant="danger"
                                                    style={{
                                                      marginLeft: "10px",
                                                    }}
                                                  >
                                                    !
                                                  </Badge>
                                                ) : null}
                                              </Form>
                                              <Form.Label>Category</Form.Label>
                                              <Form.Control
                                                as="select"
                                                custom
                                                onChange={(e) => {
                                                  this.changeCategory(
                                                    e.target.value,
                                                    consult_index
                                                  );
                                                }}
                                                value={
                                                  consultations[consult_index]
                                                    .category !== undefined
                                                    ? consultations[
                                                        consult_index
                                                      ].category
                                                    : ""
                                                }
                                              >
                                                <option value="one_to_one">
                                                  1 - 1
                                                </option>
                                                <option value="rowad">
                                                  Rowad Thakaa
                                                </option>
                                                <option value="event">
                                                  Event
                                                </option>
                                                <option value="workshop_follow_up">
                                                  Workshop Follow Up
                                                </option>
                                                <option value="competition">
                                                  Competition
                                                </option>
                                              </Form.Control>
                                              <Form.Label>Status </Form.Label>

                                              <Form.Control
                                                as="select"
                                                custom
                                                onChange={(e) => {
                                                  this.changeStatus(
                                                    e.target.value,
                                                    consult_index
                                                  );
                                                }}
                                                value={
                                                  consultations[consult_index]
                                                    .status
                                                }
                                                disabled={moment(
                                                  consultations[
                                                    consult_index
                                                  ].date.toLocaleString()
                                                ).isAfter(moment())}
                                              >
                                                <option value="pending">
                                                  Pending
                                                </option>
                                                <option value="no_show">
                                                  No-Show
                                                </option>
                                                <option value="needs_follow_up">
                                                  Needs follow up
                                                </option>
                                                <option value="complete">
                                                  Completed
                                                </option>
                                              </Form.Control>
                                              <Form.Label>Notes:</Form.Label>
                                              <Form.Control
                                                as="textarea"
                                                rows="3"
                                                onChange={(e) => {
                                                  this.setNotes(
                                                    e,
                                                    consult_index
                                                  );
                                                }}
                                                value={
                                                  consultations[consult_index]
                                                    .notes
                                                }
                                              />
                                            </Form.Group>
                                          </Form>
                                          <Card.Link
                                            href={
                                              consultations[consult_index].cal
                                            }
                                          >
                                            Calendar Link
                                          </Card.Link>
                                        </Card.Body>
                                      </Card>
                                    </Row>
                                  );
                                  return moment(
                                    consultations[
                                      consult_index
                                    ].date.toLocaleString()
                                  ).isBefore(moment()) &&
                                    (consultations[consult_index].status ===
                                      "pending" ||
                                      consultations[consult_index].duration ===
                                        "0")
                                    ? html
                                    : null;
                                }
                              )}
                            </CardDeck>
                          </Accordion.Collapse>
                        </Accordion>
                      </div>
                    ) : null;
                  })}
                </Col>
              </Col>
            </CardDeck>
          </Col>
        </Row>
        <Row>
          <hr style={{ width: "-webkit-fill-available" }}></hr>
          <Col>
            <Row>
              <h3> All Consultations</h3>
            </Row>
            {users_id_array.map((id) => {
              return (
                <div>
                  <Accordion
                    style={{
                      textAlign: "center",
                      border: "none",
                      borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Accordion.Toggle as={Button} eventKey="0" variant="link">
                      {user_data[id].firstname + " " + user_data[id].familyname}
                      <Card.Subtitle className="mb-2 text-muted">
                        {typeof user_data[id].user_type === "string"
                          ? userTypeMap[user_data[id].user_type]
                          : user_data[id].user_type.map((type, i) => {
                              return userTypeMap[type] + " | ";
                            })}
                      </Card.Subtitle>
                      <Card.Subtitle className="mb-2 text-muted">
                        {user_data[id].email + " | " + user_data[id].phone}
                      </Card.Subtitle>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <CardDeck style={{ justifyContent: "center" }}>
                        {consultations_by_user[id].map((consult_index) => {
                          let html = (
                            <Row>
                              <Card>
                                <Card.Body>
                                  <Card.Text>
                                    <h3>
                                      {moment(
                                        consultations[
                                          consult_index
                                        ].date.toLocaleString()
                                      ).format("dddd, MMMM Do YYYY, h:mm a")}
                                    </h3>
                                  </Card.Text>
                                  <Accordion
                                    style={{
                                      textAlign: "center",
                                      border: "none",
                                    }}
                                  >
                                    <Card>
                                      <Accordion.Toggle
                                        as={Card.Header}
                                        eventKey="1A"
                                        variant="link"
                                      >
                                        Questions
                                      </Accordion.Toggle>
                                      <Accordion.Collapse eventKey="1A">
                                        <Card.Body>
                                          {consultations[
                                            consult_index
                                          ].response.map((response) => {
                                            return (
                                              <Card.Text>
                                                {"Q: " + response.text}
                                                <br />
                                                {"A: " + response.answer}
                                              </Card.Text>
                                            );
                                          })}
                                        </Card.Body>
                                      </Accordion.Collapse>
                                    </Card>
                                  </Accordion>
                                  <Form>
                                    <Form.Group>
                                      <Form
                                        inline
                                        style={{
                                          justifyContent: "center",
                                          margin: "10px",
                                        }}
                                      >
                                        <Form.Label>Duration</Form.Label>
                                        <Form.Control
                                          as="select"
                                          custom
                                          onChange={(e) => {
                                            this.changeDuration(
                                              e.target.value,
                                              consult_index
                                            );
                                          }}
                                          value={
                                            consultations[consult_index]
                                              .duration
                                          }
                                          disabled={
                                            !moment(
                                              consultations[
                                                consult_index
                                              ].date.toLocaleString()
                                            ).isBefore(moment())
                                          }
                                        >
                                          <option value="0">0</option>
                                          <option value="15">15</option>
                                          <option value="30">30</option>
                                          <option value="45">45</option>
                                          <option value="60">60</option>
                                          <option value="75">75</option>
                                          <option value="90">90</option>
                                          <option value="105">105</option>
                                          <option value="120">120</option>
                                          <option value="135">135</option>
                                          <option value="150">150</option>
                                          <option value="165">165</option>
                                          <option value="180">180</option>
                                          <option value="195">195</option>
                                          <option value="210">210</option>
                                          <option value="225">255</option>
                                          <option value="240">240</option>
                                        </Form.Control>
                                      </Form>
                                      <Form.Label>Category</Form.Label>
                                      <Form.Control
                                        as="select"
                                        custom
                                        onChange={(e) => {
                                          this.changeCategory(
                                            e.target.value,
                                            consult_index
                                          );
                                        }}
                                        value={
                                          consultations[consult_index]
                                            .category !== undefined
                                            ? consultations[consult_index]
                                                .category
                                            : ""
                                        }
                                      >
                                        <option value="one_to_one">
                                          1 - 1
                                        </option>
                                        <option value="rowad">
                                          Rowad Thakaa
                                        </option>
                                        <option value="event">Event</option>
                                        <option value="workshop_follow_up">
                                          Workshop Follow Up
                                        </option>
                                        <option value="competition">
                                          Competition
                                        </option>
                                      </Form.Control>
                                      <Form.Label>Status</Form.Label>
                                      <Form.Control
                                        as="select"
                                        custom
                                        onChange={(e) => {
                                          this.changeStatus(
                                            e.target.value,
                                            consult_index
                                          );
                                        }}
                                        value={
                                          consultations[consult_index].status
                                        }
                                        disabled={moment(
                                          consultations[
                                            consult_index
                                          ].date.toLocaleString()
                                        ).isAfter(moment())}
                                      >
                                        <option value="pending">Pending</option>
                                        <option value="no_show">No-Show</option>
                                        <option value="needs_follow_up">
                                          Needs follow up
                                        </option>
                                        <option value="complete">
                                          Completed
                                        </option>
                                      </Form.Control>
                                      <Form.Label>Notes:</Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        rows="3"
                                        onChange={(e) => {
                                          this.setNotes(e, consult_index);
                                        }}
                                        value={
                                          consultations[consult_index].notes
                                        }
                                      />
                                    </Form.Group>
                                  </Form>
                                  <Card.Link
                                    href={consultations[consult_index].cal}
                                  >
                                    Calendar Link
                                  </Card.Link>
                                </Card.Body>
                              </Card>
                            </Row>
                          );
                          return html;
                        })}
                      </CardDeck>
                    </Accordion.Collapse>
                  </Accordion>
                </div>
              );
            })}
          </Col>
        </Row>
        {isChanged ? (
          <Row style={{ bottom: 0, position: "fixed" }}>
            <Button
              variant="primary"
              size="lg"
              block
              onClick={() => {
                this.saveChanges();
              }}
            >
              Save Changes
            </Button>
          </Row>
        ) : null}
      </Container>
    );
  }
}
export default withFirebase(Consultations);
